module.exports = __webpack_public_path__ + "static/img/14001035.b2ca9a94.png";